module.exports = __webpack_public_path__ + "static/media/Continental.a1984cbc.png";